import { addColumnHeader } from "../helpers";
import { getColumnData } from "../utils";

export const duplicateEntries = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns
) => {
  addColumnHeader(outputSheet, outputColumns, rule.outputColumn);
  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf)
  );

  if (useOutputOf) {
    if (rule.duplicateNTimes !== 0) {
      insertUsingDuplicateValue(
        worksheet,
        outputSheet,
        useOutputOf.inputColumn,
        useOutputOf.output,
        rule.outputColumn,
        rule.duplicateNTimes
      );
    } else if (useOutputOf.ranges) {
      duplicateEntriesForRanges(
        worksheet,
        outputSheet,
        useOutputOf.inputColumn,
        rule.outputColumn,
        useOutputOf.output
      );
    } else {
      insertDuplicateEntryUsingIndexes(
        worksheet,
        outputSheet,
        useOutputOf.inputColumn,
        rule.outputColumn,
        useOutputOf.output
      );
    }
  }
};

const insertUsingDuplicateValue = (
  worksheet,
  outputSheet,
  inputColumn,
  indexes,
  outputColumn,
  duplicateNo
) => {
  let outputRow = 2;
  indexes.forEach((ind) => {
    const inputCellValue = worksheet.getCell(`${inputColumn}${ind}`).value;
    for (let i = 0; i < duplicateNo; i++) {
      outputSheet.getCell(`${outputColumn}${outputRow}`).value = inputCellValue;
      outputRow++;
    }
  });
};

const insertDuplicateEntryUsingIndexes = (
  worksheet,
  outputSheet,
  inputColumn,
  outputColumn,
  indexes
) => {
  let outputRow = 2;
  for (let i = 0; i < indexes.length; i++) {
    const startIndex = indexes[i] + 1;
    const endIndex = indexes[i + 1] ?? worksheet.rowCount + 1;
    const inputCellValue = worksheet.getCell(
      `${inputColumn}${indexes[i]}`
    ).value;
    for (let rowIndex = startIndex; rowIndex < endIndex; rowIndex++) {
      outputSheet.getCell(`${outputColumn}${outputRow}`).value = inputCellValue;
      outputRow++;
    }
  }
};

const duplicateEntriesForRanges = (
  worksheet,
  outputSheet,
  inputColumn,
  outputColumn,
  ranges
) => {
  let outputRow = 2;
  for (let i = 0; i < ranges.length; i++) {
    const [startRow, endRow] = ranges[i];
    const inputCellValue = worksheet.getCell(`${inputColumn}${startRow}`).value;

    for (let rowIndex = startRow + 1; rowIndex <= endRow; rowIndex++) {
      outputSheet.getCell(`${outputColumn}${outputRow}`).value = inputCellValue;
      outputRow++;
    }
  }
};
